/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

const RevealDotsVertical = (props) => (
  <svg className={props.className} xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
    <g>
      <path d="M9.5,12.17a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,9.5,12.17Z"/>
      <path d="M9.5,4A2.5,2.5,0,1,1,12,6.49,2.5,2.5,0,0,1,9.5,4Z"/>
      <path d="M9.5,20.34a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,9.5,20.34Z"/>
    </g>
  </svg>
);

export default RevealDotsVertical;
